import { Badge } from "@/components/ui/badge"

export function SectionHeading({ eyebrow, title, description, light = false }: { eyebrow: string; title: string; description?: string; light?: boolean }) {
  return (
    <div className="max-w-3xl">
      <Badge className={light ? "text-emerald-200" : "text-emerald-800 dark:text-emerald-300"}>{eyebrow}</Badge>
      <h2 className={`mt-5 text-balance text-4xl font-semibold tracking-[-.05em] sm:text-5xl ${light ? "text-white" : "text-slate-950 dark:text-white"}`}>{title}</h2>
      {description && <p className={`mt-5 max-w-2xl text-base leading-7 sm:text-lg ${light ? "text-white/65" : "text-slate-600 dark:text-slate-400"}`}>{description}</p>}
    </div>
  )
}
